
import { useState, useMemo, useEffect, useRef } from 'react';
import Webcam from "react-webcam";

import filtericon from '../../../assets/icons/mage_filter-fill.svg'
import '../../../assets/css/StudentDashboard.css'
import SearchBar from '../../../Component/SearchBar.js';
import Table from '../../../Component/Table.js';
import image from '../../../assets/Images/image.png';
import phone from '../../../assets/icons/ic_round-phone.svg';
import whatsapp from '../../../assets/icons/logos_whatsapp-icon.svg';
import edit from '../../../assets/icons/editnew.svg';
import { useNavigate } from 'react-router-dom';
import { UserShortDetails } from './EmployeeShortDetails.js';
import AddNewEmployeeModal from '../../../Component/Modals/AddNewEmployeeModal.js';
import { WaitApprovalForEmployeeChange } from '../../../Component/Modals/WaitApprovalForEmployeeChange.js';
import { getData, patchData, Postdata, Postdataform, updateData } from '../../../API/GlobalApi.js';
import { validateEmail } from '../../../Utils/ValidationService.js';
import debounce from 'lodash.debounce';
import successgif from '../../../assets/gif/successfullgif.gif';
import close from '../../../assets/icons/close.svg';
import tablelast from '../../../assets/icons/tablelast.svg';
import { GenerateEmployeeIdModal } from '../../../Component/Modals/GenerateEmployeeID.js';
import { PhotoEditor } from '../../../Component/PhotoEditor.js';
import Session from '../../../Utils/Sessions.js';
import { highlightMatch } from '../../../Utils/highlightSearchFunctions.js';
import Notifier from '../../../Utils/notify.js'
import { useTableFade } from '../../../Utils/tableFadeHooks.js';
import TableLoaderOverlay from '../../../Utils/tableFadingLoader.js';
const EmployeeDashboard = () => {

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpendept, setIsModalOpendept] = useState(false);
  const [submit, setsubmit] = useState(false);
  const [dnparentdata, setdnparentdata] = useState([]);
  const [countryId, setcountryId] = useState(null);
  const [countrydata, setcountrydata] = useState([]);
  const [statedata, setstatedata] = useState([]);
  const [citydata, setcitydata] = useState([]);
  const [stateid, setstateid] = useState(null);
  const [cityid, setcityid] = useState(null);
  const [selectedOrgDetails, setSelectedOrgDetails] = useState([]);
  const [departmentdetails, setdepartmentdetails] = useState(null);
  const [parentorgid, setparentorgid] = useState(null);
  const [parentorgidsub, setparentorgidsub] = useState(null);
  const [Updatebtn, setUpdatebtn] = useState(false);
  const [status, setStatus] = useState(false);
  const [uploaddoc, setgetuploaddocmaster] = useState([]);
  const [getbasicmaster, setgetbasicmaster] = useState([]);
  const [getofficialdetailmaster, setgetofficialdetailmaster] = useState([]);
  const [emoployeeId, setemoployeeId] = useState(null);
  const [showCamera, setShowCamera] = useState(false);
  const [capturedPhoto, setCapturedPhoto] = useState(null);
  const [employeeImageFile, setEmployeeImageFile] = useState(null);
  const [parentidfromorg, setparentidfromorg] = useState(null)
  const [departmentidfromorg, setdepartmentidfromorg] = useState(null)
  const [departmentfromorg, setdepartmentfromorg] = useState([]);
  const [reporttofromorg, setreporttofromorg] = useState([]);
  const [desigfromorg, setdesigfromorg] = useState([]);
  const [isEditMode, setIsEditMode] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [getemployeesdata, setgetemployeesdata] = useState([]);
  const [getemployeesdataId, setgetemployeesdataId] = useState(null);
  const [dpimgpath, setdpimgpath] = useState('');
  const [currentStep, setCurrentStep] = useState(0);
  const webcamRef = useRef(null);
  const [attendanceType, setAttendanceType] = useState('Biometric Attendance');
  const [biometricImages, setBiometricImages] = useState([]);
  const [geoLocation, setGeoLocation] = useState('');
  const [searchLocation, setSearchLocation] = useState('');
  const [periphery, setPeriphery] = useState('');
  const [selectedPlace, setSelectedPlace] = useState(null);
  const [totalCount, setTotalCount] = useState(0);
  const [funcsuc, setfuncsuc] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [newPermissions, setNewPermissions] = useState([]);
  const [approvalRequestId, setApprovalRequestId] = useState(null);
  const [editSessionId, setEditSessionId] = useState(null);

  // Start an EmployeeEditSession the instant the Add/Edit modal opens.
  // The backend captures a snapshot of the Employee + nested rows, which is
  // then used by Save & Close to compute the cumulative diff, and by Reject
  // to revert every Save & Next change made during the session.
  const startEditSession = async (employeeId) => {
    try {
      const resp = await Postdata('staff/employee-edit-sessions/', {
        employee_id: employeeId || null,
      });
      if (resp && resp.session_id) {
        setEditSessionId(resp.session_id);
      }
    } catch (err) {
      console.warn('Failed to start edit session', err);
    }
  };
  const [assignedCourses, setAssignedCourses] = useState([]);
  const [allCourses, setAllCourses] = useState([]);
  const [attendanceid, setattendanceid] = useState(null);
  const [orgdata, setorgdata] = useState([]);
  const pageSize = 10;
  const [isLoadingFormDetails, setIsLoadingFormDetails] = useState(false);
  const [idcardmodal, setidcardmodal] = useState(false);
  const [idcarddata, setidcarddata] = useState([]);
  const [imgurl, setimgurl] = useState('')
  const [fingerprints, setFingerprints] = useState([null, null, null]);
  const [showEditor, setShowEditor] = useState(false);
  const [showvaliditymodal, setshowvaliditymodal] = useState(false);
  const [orgform, setorgform] = useState({
    salutation: "",
    first_name: "",
    middle_name: "",
    last_name: "",
    alias: "",
    gender: "",
    date_of_birth: "",
    blood_group: "",
    marital_status: "",
    father_name: "",
    mother_name: "",
    husband_name: "",
    email: ""
  })
  // const [uploaddocuments form]
  const [deptform, setdeptform] = useState({
    name: "",
    parent_department_id: null,
    country_code: "",
    area_code: '',
    landline: "",
    mobile: "",
    email: ""
  })
  const [contactDetails, setContactDetails] = useState([
    { number: '', contact_type: 'Personal', is_available_on_whatsapp: false, is_primary: true, country_code: '+91' }
  ]);
  const [correspondenceAddress, setCorrespondenceAddress] = useState({
    address: '',
    country: '',
    state: '',
    city: '',
    pincode: ''
  });

  const [permanentAddress, setPermanentAddress] = useState({
    address: '',
    country: '',
    state: '',
    city: '',
    pincode: ''
  });

  const [sameAsCorrespondence, setSameAsCorrespondence] = useState(false);

  const [academicDocs, setAcademicDocs] = useState([
    { id: Date.now(), qualification: '', board: '', specialization: '', percentage: '', file: null, name: '' }
  ]);

  const [otherDocs, setOtherDocs] = useState([
    { id: Date.now(), documentType: '', documentNumber: '', expiryDate: '', file: null, name: '' }
  ]);
  const [officialDetails, setOfficialDetails] = useState({
    organization: '',
    department: '',
    designation: '',
    reportTo: '',
    employeeCode: '',
    uniquecode: '',
    workingShift: '',
    dateOfJoining: '',
    employmentType: '',
    subjects: ['']
  });
  const [bankDetails, setBankDetails] = useState({
    accountHolderName: '',
    bankName: '',
    accountNumber: ''
  });
  const [showToast, setShowToast] = useState(false);
  const [toastVariant, setToastVariant] = useState('success');
  const [toastMessage, setToastMessage] = useState('');
  const [searchQuery, setSearchQuery] = useState('');
  const [filterQueryString, setFilterQueryString] = useState('');
  const navigate = useNavigate();
  const capture = () => {
    const imageSrc = webcamRef.current.getScreenshot();
    setCapturedPhoto(imageSrc);
    setShowCamera(false);
  };
  const displayToast = (message, variant = 'success') => {
    setToastMessage(message);
    setToastVariant(variant);
    setShowToast(true);

    setTimeout(() => setShowToast(false), 3000);
  };

  // DRF errors come back as {error: [..]}, {detail: ".."}, {field: [..]} or
  // nested lists of those (e.g. {addresses: [{}, {error: [..]}]}).
  const extractApiError = (data, fallback = 'Something went wrong') => {
    if (!data) return fallback;
    if (typeof data === 'string') return data;
    if (Array.isArray(data)) {
      for (const item of data) {
        const msg = extractApiError(item, '');
        if (msg) return msg;
      }
      return fallback;
    }
    if (typeof data === 'object') {
      for (const [key, value] of Object.entries(data)) {
        const msg = extractApiError(value, '');
        if (!msg) continue;
        if (['error', 'detail', 'non_field_errors', 'message'].includes(key)) return msg;
        const label = key.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
        return `${label}: ${msg}`;
      }
    }
    return fallback;
  };

  const isBlank = (v) => v === undefined || v === null || String(v).trim() === '';
  // Select placeholders in BasicDetails use value "0".
  const isUnselected = (v) => isBlank(v) || String(v) === '0';

  const getCurrentEmployeeId = () => {
    const id = emoployeeId || selectedUserId || sessionStorage.getItem('employeeId');
    return id && id !== 'undefined' && id !== 'null' ? id : null;
  };

  const getMissingBasicFields = (obj) => {
    const missing = [];
    if (isUnselected(obj.salutation)) missing.push('Salutation');
    if (isBlank(obj.first_name)) missing.push('First Name');
    if (isBlank(obj.last_name)) missing.push('Last Name');
    if (isBlank(obj.alias)) missing.push('Alias Name');
    if (isUnselected(obj.gender)) missing.push('Gender');
    if (isBlank(obj.date_of_birth)) missing.push('Date of Birth');
    if (isUnselected(obj.marital_status)) missing.push('Marital Status');
    if (isBlank(obj.father_name)) missing.push("Father's Name");
    if (!validateEmail(obj.email || '')) missing.push('Valid Email');
    (obj.contact_numbers || []).forEach((c, i) => {
      if (!/^\d{10}$/.test(String(c.number ?? '').trim())) missing.push(`Mobile Number ${i + 1} (10 digits)`);
    });
    const labels = { Current: 'Correspondence', Permanent: 'Permanent' };
    (obj.addresses || []).forEach((a) => {
      const prefix = labels[a.address_type] || a.address_type;
      if (isBlank(a.address)) missing.push(`${prefix} Address`);
      if (isBlank(a.country_id)) missing.push(`${prefix} Country`);
      if (isBlank(a.state_id)) missing.push(`${prefix} State`);
      if (isBlank(a.city_id)) missing.push(`${prefix} City`);
      if (!/^\d{6}$/.test(String(a.pincode ?? '').trim())) missing.push(`${prefix} Pin Code (6 digits)`);
    });
    return missing;
  };

  const handleEditClick = (userId, rowdata) => {

    sessionStorage.setItem('employeeId', userId);
    setSelectedUserId(userId);
    setattendanceid(rowdata.configuration)
    setemoployeeId(userId);
    setIsEditMode(true);
    setIsModalOpen(true);
    startEditSession(userId);
  };
  const getorgdataorg = async (page = 1) => {

    const url = `administration/organizations/`;
    const response = await getData(url);
    if (response) {
      setorgdata(response);

    }
  };
  const getorgdata = async (page = 1) => {

    const url = `administration/designations-no-pagination/`;
    const response = await getData(url);
    if (response) {
      setdnparentdata(response);

    }
  };
  const handleSameAsCorrespondence = (e) => {
    const checked = e.target.checked;
    setSameAsCorrespondence(checked);
    if (checked) {
      setPermanentAddress({ ...correspondenceAddress });
    }
  };
  const handleCorrespondenceChange = (e) => {
    const { name, value } = e.target;
    setCorrespondenceAddress(prev => ({ ...prev, [name]: value }));
  };
  const handlePermanentChange = (e) => {
    const { name, value } = e.target;
    setPermanentAddress(prev => ({ ...prev, [name]: value }));
  };
  const handlePermissionChange = (e, permission) => {
    if (e.target.checked) {
      setNewPermissions(prev => [...prev, { id: permission.id, name: permission.name }]);
    } else {
      setNewPermissions(prev =>
        prev.filter(p => p.id !== permission.id)
      );
    }
  };


  const handleSearchold = (query) => {
    setSearchQuery(query);
  };
  const getbasicmasterdata = async () => {
    const url = "staff/teacher-basic-details/get-master-data/";
    const response = await getData(url);
    if (response) {
      setgetbasicmaster(response.master);

    }
  }
  const getuploaddocmasterdata = async () => {
    const url = "staff/teacher-document-details/get-master-data/";
    const response = await getData(url);
    if (response) {
      setgetuploaddocmaster(response.master);


    }
  }
  const getofficialdetailmasterdata = async () => {
    const url = "staff/teacher-official-details/get-master-data/";
    const response = await getData(url);
    if (response) {
      setgetofficialdetailmaster(response.master);
    }
  }
  const getAllCourses = async () => {
    const response = await getData('students/students-basic-details/master-data/');
    if (response?.courses) {
      setAllCourses(response.courses);
    }
  };

  const getdeptdata = async (res) => {
    setparentorgid(res);

    const url = `administration/organizations/${res}/departments/`;
    const response = await getData(url);
    if (response) {
      setdepartmentdetails(response);
    }

  }
  const getcountry = async () => {
    const url = "administration/countries/";
    const response = await getData(url);
    setcountrydata(response)

  }
  const handlelocationdata = async (e) => {
    const value = e.target.value;
    const name = e.target.name;

    if (name === "country") {
      setcountryId(value)

      try {
        const url = `administration/countries/${value}/states/`

        const response = await getData(url);
        if (response) {
          setstatedata(response.state_list)
        }
      } catch (error) {

      }
    }
    else if (name === 'state') {
      setstateid(value)
      try {
        const url = `administration/countries/${countryId}/states/${value}/cities/`

        const response = await getData(url);

        if (response) {
          setcitydata(response.city_list)
        }
      } catch (error) {

      }
    }
    else if (name === 'city') {
      setcityid(value)
    }
  }
  const handleChange = (e) => {
    const { name, value } = e.target;
    setorgform(prevState => ({
      ...prevState,
      [name]: value
    }));
  };
  const handleContactChange = (index, field, value) => {
    const updatedContacts = [...contactDetails];
    updatedContacts[index][field] = value;
    setContactDetails(updatedContacts);
  };
  const handlePrimarySelect = (index) => {
    const updatedContacts = contactDetails.map((contact, i) => ({
      ...contact,
      is_primary: i === index
    }));
    setContactDetails(updatedContacts);
  };
  const handleAcademicChange = (e, id) => {
    const { name, value } = e.target;

    const updatedDocs = academicDocs.map(doc =>
      doc.id === id ? { ...doc, [name]: value } : doc

    );
    setAcademicDocs(updatedDocs);
  };

  const handleOtherDocChange = (e, id) => {
    const { name, value } = e.target;

    const updatedDocs = otherDocs.map(doc =>
      doc.id === id ? { ...doc, [name]: value } : doc

    );
    setOtherDocs(updatedDocs);
  };
  const handleAcademicFileChange = (e, id) => {
    const file = e.target.files[0];
    const updatedDocs = academicDocs.map(doc =>

      doc.id === id ? { ...doc, file, name: file ? file.name : '' } : doc
    );
    setAcademicDocs(updatedDocs);
  };
  const handleAcademicFileRemove = (id) => {
    const updatedDocs = academicDocs.map(doc =>
      doc.id === id ? { ...doc, file: null, name: '' } : doc
    );
    setAcademicDocs(updatedDocs);
  };
  const handleOtherFileChange = (e, id) => {
    const file = e.target.files[0];
    const updatedDocs = otherDocs.map(doc =>
      doc.id === id
        ? { ...doc, file, fileName: file ? file.name : 'No File Selected' }
        : doc
    );
    setOtherDocs(updatedDocs);
  };
  const handleRemoveOtherFile = (id) => {
    const updatedDocs = otherDocs.map(doc =>
      doc.id === id
        ? { ...doc, file: null, fileName: 'No File Selected', fileSize: 0, name: '' }
        : doc
    );
    setOtherDocs(updatedDocs);
  };
  const handleEmployeeImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setEmployeeImageFile(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setCapturedPhoto(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };
  // Returns the uploaded file path, null when there is no new image to upload
  // (nothing picked, or the existing picture is unchanged), or false on failure.
  const submitEmployeeImage = async () => {
    const apiUrl = "staff/upload-file/";
    let formData = new FormData();

    if (employeeImageFile instanceof File) {
      formData.append("file", employeeImageFile);
    } else if (typeof capturedPhoto === 'string' && capturedPhoto.startsWith('data:')) {
      const blob = await fetch(capturedPhoto).then(res => res.blob());
      const file = new File([blob], "captured-photo.jpg", { type: "image/jpeg" });
      formData.append("file", file);
    } else {
      return null;
    }

    try {
      const response = await Postdataform(apiUrl, formData)
      if (!response?.file_url) {
        displayToast(extractApiError(response, 'Image upload failed'), 'danger');
        return false;
      }
      return response.file_url;

    } catch (error) {

      displayToast('Image upload failed', 'danger')
      return false;
    }
  };
  const handleOfficialChangeold = (e, index) => {
    const { name, value } = e.target;
    const updated = [...officialDetails];
    updated[index][name] = value;
    setOfficialDetails(updated);
  };
  const handleOfficialChange = async (e, index) => {
    const { name, value } = e.target;

    setOfficialDetails(prev => ({
      ...prev,
      [name]: value
    }));
    if (name === 'organization') {
      if (!value) {
        setdepartmentfromorg([]);
        setOfficialDetails(prev => ({ ...prev, department: "" }));
        return;
      }
      setparentidfromorg(value);
      const urldept = `administration/organizations/${value}/departments/`;
      const response = await getData(urldept);
      setdepartmentfromorg(Array.isArray(response) ? response : []);
      setOfficialDetails(prev => ({ ...prev, department: "" }));
    }

    if (name === 'department') {
      if (!value) return;
      const orgId = officialDetails.organization;
      if (!orgId) return
      setdepartmentidfromorg(value);
      const url = `administration/organizations/${parentidfromorg}/departments/${value}/designations/`;
      const response = await getData(url);
      setreporttofromorg(response);
      setdesigfromorg(response);
    }
  };
  const handleBankChange = (e) => {
    const { name, value } = e.target;
    setBankDetails({ ...bankDetails, [name]: value });
  };
  const handleChangedept = (e) => {
    const { name, value } = e.target;
    setdeptform(prevState => ({
      ...prevState,
      [name]: value
    }));
  }
  const handleSubmitbasic = async (submitMode = 'save_and_next') => {
    const permanent = sameAsCorrespondence ? correspondenceAddress : permanentAddress;
    const finalobj = {
      submit_mode: submitMode,
      session_id: editSessionId,
      salutation: orgform.salutation,
      first_name: orgform.first_name,
      middle_name: orgform.middle_name,
      last_name: orgform.last_name,
      alias: orgform.alias,
      gender: orgform.gender,
      date_of_birth: orgform.date_of_birth,
      blood_group: orgform.blood_group,
      marital_status: orgform.marital_status,
      father_name: orgform.father_name,
      mother_name: orgform.mother_name,
      husband_name: orgform.salutation === 'Mrs.' ? (orgform.husband_name || '') : '',
      email: orgform.email,
      contact_numbers: contactDetails,
      addresses: [
        {
          address_type: "Current",
          address: correspondenceAddress.address,
          city_id: correspondenceAddress.city,
          state_id: correspondenceAddress.state,
          country_id: correspondenceAddress.country,
          pincode: correspondenceAddress.pincode
        },
        {
          address_type: "Permanent",
          address: permanent.address,
          city_id: permanent.city,
          state_id: permanent.state,
          country_id: permanent.country,
          pincode: permanent.pincode
        }

      ]

    }

    const missing = getMissingBasicFields(finalobj);
    if (missing.length > 0) {
      displayToast(`Please fill: ${missing.join(', ')}`, 'danger');
      return false;
    }

    const url = 'staff/teacher-basic-details/';

    const response = await Postdata(url, finalobj);
    if (response?.status === 'pending_approval' && response?.request_id) {
      setApprovalRequestId(response.request_id);
      displayToast('Approval request sent on WhatsApp. Waiting for response...', 'success');
      return false;
    }
    if (response?.user_id) {
      setfuncsuc(true);
      displayToast('Basic Details Submit SuccessFully', 'success');
      setemoployeeId(response.user_id);
      getemployees();
      sessionStorage.setItem("employeeId", response.user_id)
      return true;
    }
    displayToast(extractApiError(response), 'danger');
    return false;
  }
  const handleSubmituploaddocument = async (submitMode = 'save_and_next') => {
    setfuncsuc(false);
    const employee_id = getCurrentEmployeeId();
    if (!employee_id) {
      displayToast('Please save Basic Details first.', 'danger');
      return false;
    }

    const qualifications = academicDocs.map(doc => {

      const documentName = typeof doc.file === 'string'
        ? doc.file.split('/').pop()
        : doc.file?.name || '';

      return {
        qualification_type: doc.qualification,
        board: doc.board,
        percentage: parseFloat(doc.percentage || 0),
        subjects: doc.specialization ? [{ subject: doc.specialization }] : [],
        documents: doc.file
          ? [{
            document: documentName,
            document_type: "Certificate"
          }]
          : []
      };
    });


    const employee_documents = otherDocs.map(doc => {

      const documentName = typeof doc.file === 'string'
        ? doc.file.split('/').pop()
        : doc.file?.name || '';

      return {
        document_type: doc.documentType,
        document_number: doc.documentNumber,
        document: documentName || "No File Selected",
        validity: doc.expiryDate || null
      };
    });
    const missing = [];
    qualifications.forEach((q, i) => {
      const row = `Qualification ${i + 1}`;
      if (!q.qualification_type) missing.push(`${row} type`);
      if (!q.board) missing.push(`${row} board/university`);
      if (q.subjects.length === 0) missing.push(`${row} specialization`);
      if (!q.documents[0]?.document) missing.push(`${row} document`);
    });
    employee_documents.forEach((doc, i) => {
      const row = `Other Document ${i + 1}`;
      if (!doc.document_type) missing.push(`${row} type`);
      if (!doc.document_number) missing.push(`${row} number`);
      if (!doc.document || doc.document === 'No File Selected') missing.push(`${row} file`);
    });
    if (missing.length > 0) {
      displayToast(`Please fill: ${missing.join(', ')}`, 'danger');
      return false;
    }

    const dpFileUrl = await submitEmployeeImage();
    if (dpFileUrl === false) return false;

    const payload = {
      submit_mode: submitMode,
      session_id: editSessionId,
      employee_id,
      qualifications,
      employee_documents,
      // null keeps the existing picture on the backend
      profile_picture: dpFileUrl
    };

    const url = 'staff/teacher-document-details/';
    const response = await Postdata(url, payload);

    if (response?.status === 'pending_approval' && response?.request_id) {
      setApprovalRequestId(response.request_id);
      displayToast('Approval request sent on WhatsApp. Waiting for response...', 'success');
      return false;
    }
    if (response && Array.isArray(response.qualifications)) {
      setfuncsuc(true);
      displayToast('Documents Uploaded Successfully', 'success');
      getorgdata();
      getemployees();

      setEmployeeImageFile(null);
      setCapturedPhoto(null);

      return true;
    }
    displayToast(extractApiError(response, 'Submission failed'), 'danger');
    return false;
  };

  const handleSubmitOfficialDetailsold = async () => {
    setfuncsuc(false);
    const token = sessionStorage.getItem("token");
    const employeeId = sessionStorage.getItem("employeeId")
    const employee_id = emoployeeId ? emoployeeId : employeeId;

    if (!officialDetails || officialDetails.length === 0) {
      displayToast('Please fill in official details', 'danger');

      return;
    }

    const payload = {
      user_id: Number(employee_id),
      organization_id: Number(officialDetails.organization) || 0,
      department_id: Number(officialDetails.department) || 0,
      designation_id: Number(officialDetails.designation) || 0,
      unique_code: officialDetails.employeeCode || "EMP-001",
      working_shift: officialDetails.workingShift || "Morning",
      date_of_joining: officialDetails.dateOfJoining || new Date().toISOString().split("T")[0],
      employment_type: officialDetails.employmentType || "Full Time",
      manager: Number(officialDetails.reportTo) || 0,
      // subjects: (officialDetails.subjects || []).filter(Boolean), 
      bank_id: 1, // optional if you're not sending it
      account_holder_name: bankDetails.accountHolderName || "",
      bank_account_number: bankDetails.accountNumber || ""
    };

    // (payload.organization_id.length > 0 && payload.department_id.length > 0 && payload.designation_id.length > 0 && payload.account_holder_name.length > 0 && payload.bank_account_number.length > 0) 
    if (payload.organization_id.length > 0 && payload.department_id.length > 0 && payload.designation_id.length > 0) {
      try {

        const response = await updateData(`staff/teacher-official-details/${employee_id}/`, payload)

        if (!response.error) {
          setfuncsuc(true);
          displayToast('Official details saved successfully', 'success');
          return true;
        }

      } catch (error) {

        displayToast(error, 'danger');
        return false;
      }
    }
    else {
      displayToast('Fill All the required details', 'danger');
      return false;
    }
  };




  const handleSubmitOfficialDetails = async (submitMode = 'save_and_next') => {
    setfuncsuc(false);
    const employee_id = getCurrentEmployeeId();
    if (!employee_id) {
      displayToast('Please save Basic Details first.', 'danger');
      return false;
    }
    const payload = {
      submit_mode: submitMode,
      session_id: editSessionId,
      user_id: Number(employee_id),
      organization_id: Number(officialDetails.organization) || 0,
      department_id: Number(officialDetails.department) || 0,
      designation_id: Number(officialDetails.designation) || 0,
      working_shift: officialDetails.workingShift || "",
      date_of_joining: officialDetails.dateOfJoining || new Date().toISOString().split("T")[0],
      employment_type: officialDetails.employmentType || "Full Time",
      manager: Number(officialDetails.reportTo) || null,
      unique_code: officialDetails.uniquecode,
      bank_id: bankDetails.bank_id || null,
      account_holder_name: bankDetails.accountHolderName || "",
      bank_account_number: bankDetails.accountNumber || "",
      new_permissions: newPermissions,
      subjects: assignedCourses.map(c => c.value),
    };


    if (
      payload.organization_id &&
      payload.department_id &&
      payload.designation_id
      // payload.account_holder_name &&
      // payload.bank_account_number
    ) {
      try {
        const response = await updateData(`staff/teacher-official-details/${employee_id}/`, payload);

        if (response?.status === 'pending_approval' && response?.request_id) {
          setApprovalRequestId(response.request_id);
          displayToast('Approval request sent on WhatsApp. Waiting for response...', 'success');
          return false;
        }

        if (response?.user_id) {

          setfuncsuc(true);
          displayToast('Official details saved successfully', 'success');
          getemployees();
          return true;
        } else {
          displayToast(extractApiError(response), "danger");
          return false;

        }
      } catch (error) {

        displayToast('Failed to save official details', 'danger');
        return false;
      }
    } else {
      const missing = [];
      if (!payload.organization_id) missing.push('Institution');
      if (!payload.department_id) missing.push('Department');
      if (!payload.designation_id) missing.push('Designation');
      displayToast(`Please fill: ${missing.join(', ')}`, 'danger');
      return false;
    }
  };

  const handleSubmitdept = async () => {
    const finalobj = {
      name: deptform.name,
      parent_department_id: null,
      country_code: "+91",
      area_code: '1',
      landline: deptform.landline,
      mobile: deptform.mobile,
      email: deptform.email
    }
    const url = `administration/organizations/${parentorgid}/departments/`;
    const response = Postdata(url, finalobj);
    if (!response.error) {
      getdeptdata(parentorgid)
    }

  }
  const handleFilterClick = () => {
    // onFilter(searchQuery); 
  };
  const openModal = () => {
    // Drop any id left over from a previous add/edit so later steps can't
    // write to the wrong (or a deleted) employee.
    sessionStorage.removeItem('employeeId');
    setemoployeeId(null);
    setIsModalOpen(true);
    // Add Employee flow — start a session with no employee yet; the backend
    // will be linked to the new Employee row once Basic Details Save & Next
    // creates it.
    startEditSession(null);
  };
  const closeModal = () => {
    setIsModalOpen(false);
    setUpdatebtn(false);
    setSelectedUserId(null);
    handleClear();
    setIsEditMode(false);
    setEditSessionId(null);
    setemoployeeId(null);
    sessionStorage.removeItem('employeeId');
  };
  const openModaldept = () => {
    setIsModalOpendept(true);
  };
  const closeModaldept = () => {
    setIsModalOpendept(false);
    handleCleardept();
    setUpdatebtn(false);
  };
  const submitclose = () => {
    setsubmit(false);
  };
  const handleRowClick = async (userId, row) => {
    const token = sessionStorage.getItem("token");

    try {

      const response = await getData(`staff/get-employees/${userId}/`)

      setSelectedOrgDetails(response);

      localStorage.setItem("selectedEmployeeData", JSON.stringify(response));


    } catch (error) {
      displayToast("❌ Error fetching employee data:", 'danger');
    }
  };
  const handleEdit = (row) => {
    const orgData = row.original;

    setorgform({
      id: orgData.id,
      orgname: orgData.name,
      parentorgidog: orgData.id,
      gstin: orgData.gstin,
      email: orgData.email,
      landlineno: orgData.landline,
      mobileno: orgData.mobile,
      address: orgData.address,
      pincode: orgData.pincode,
      countrycode: orgData.country_code || '91',
    });
    setparentorgidsub(orgData.id);
    setcountryId(orgData.country_id);
    setstateid(orgData.state_id)

    openModal();
    setUpdatebtn(true);

  };
  const handleEditdept = (row) => {
    setdeptform(
      {
        id: row.id,
        name: row.name,
        parent_department_id: null,
        country_code: "+91",
        area_code: '1',
        landline: row.landline,
        mobile: row.mobile,
        email: row.email
      }
    )
    setUpdatebtn(true);
    openModaldept();
  }
  const handleupdatedept = async () => {
    const finalobj = {
      id: deptform.id,
      name: deptform.name,
      parent_department_id: null,
      country_code: '+91',
      area_code: "1",
      landline: deptform.landline,
      mobile: deptform.mobile,
      email: deptform.email
    }
    const url = `administration/organizations/${parentorgid}/departments/${finalobj.id}/`

    const response = await updateData(url, finalobj);
    if (response) {
      closeModaldept();
      setUpdatebtn(false);
      getdeptdata(parentorgid);
    }
  }
  const handleUpdate = async () => {
    const finalobj = {
      id: orgform.id,
      name: orgform.orgname,
      parent_organization_id: parentorgidsub,
      gstin: orgform.gstin,
      email: orgform.email,
      landline: orgform.landlineno,
      mobile: orgform.mobileno,
      address: orgform.address,
      pincode: orgform.pincode,
      country_code: '+91',
      country_id: countryId,
      state_id: stateid,
      city_id: cityid,
      area_code: '1'

    }
    const url = `administration/organizations/${finalobj.id}/`
    const response = await updateData(url, finalobj);
    if (!response.error) {
      getorgdata();
      setUpdatebtn(false);
      closeModal();
    }
  }
  const handleUpdateBasicDetails = async (submitMode = 'save_and_next') => {
    const employee_id = getCurrentEmployeeId();
    if (!employee_id) {
      displayToast('Employee not found. Please close and reopen the form.', 'danger');
      return false;
    }
    const permanent = sameAsCorrespondence ? correspondenceAddress : permanentAddress;
    const finalobj = {
      submit_mode: submitMode,
      session_id: editSessionId,
      salutation: orgform.salutation,
      first_name: orgform.first_name,
      middle_name: orgform.middle_name,
      last_name: orgform.last_name,
      alias: orgform.alias,
      gender: orgform.gender,
      date_of_birth: orgform.date_of_birth,
      blood_group: orgform.blood_group,
      marital_status: orgform.marital_status,
      father_name: orgform.father_name,
      mother_name: orgform.mother_name,
      husband_name: orgform.salutation === 'Mrs.' ? (orgform.husband_name || '') : '',
      email: orgform.email,
      contact_numbers: contactDetails,

      addresses: [
        {
          address_type: "Current",
          address: correspondenceAddress.address,
          city_id: correspondenceAddress.city,
          state_id: correspondenceAddress.state,
          country_id: correspondenceAddress.country,
          pincode: correspondenceAddress.pincode
        },
        {
          address_type: "Permanent",
          address: permanent.address,
          city_id: permanent.city,
          state_id: permanent.state,
          country_id: permanent.country,
          pincode: permanent.pincode
        }

      ]
    }
    const missing = getMissingBasicFields(finalobj);
    if (missing.length > 0) {
      displayToast(`Please fill: ${missing.join(', ')}`, 'danger');
      return false;
    }

    const url = `staff/teacher-basic-details/${employee_id}/`;

    const response = await updateData(url, finalobj);

    if (response?.status === 'pending_approval' && response?.request_id) {
      setApprovalRequestId(response.request_id);
      displayToast('Approval request sent on WhatsApp. Waiting for response...', 'success');
      return false;
    }
    if (response?.user_id) {
      setfuncsuc(true);
      setemoployeeId(response.user_id);
      sessionStorage.setItem("employeeId", response.user_id)
      displayToast("Basic Details Uploaded Successfully", 'success')
      // getorgdata()
      getemployees()
      return true;
    }

    // Extract and prettify backend error
    let errorMessage = extractApiError(response, "Something went wrong!");

    if (errorMessage.includes("Duplicate entry")) {
      if (errorMessage.includes("core_users.mobile")) {
        errorMessage = "Mobile number already exists.";
      } else if (errorMessage.includes("core_users.email")) {
        errorMessage = "Email address already exists.";
      } else if (errorMessage.includes("core_users.username")) {
        errorMessage = "Username already exists.";
      } else {
        errorMessage = "Duplicate entry found.";
      }
    }

    displayToast(errorMessage, 'danger');
    return false;
  }
  const dataemploye = useMemo(() => {
    return getemployeesdata?.map((emp) => ({
      id: emp.user_id,
      unique_code: emp.unique_code,
      name: `${emp.first_name || ''} ${emp.middle_name || ''} ${emp.last_name || ''}`.trim(),
      email: emp.email || '',
      department_name: emp.department?.name || '',
      designation: emp.designation?.name || '',
      contacts: emp.contact_numbers || [],
      img: emp.latest_photo?.document || null,
      profile_pic: emp.profile_picture || '',
      status: emp.status,
      configuration: emp.configuration,
      handleRowClick: handleRowClick
    }));
  }, [getemployeesdata]);

  const filteredData = useMemo(() => {
    if (!searchQuery) {
      return dataemploye;
    }
    return dataemploye.filter((org) =>
      org.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      org.email.toLowerCase().includes(searchQuery.toLowerCase())
      // org.id.toString().includes(searchQuery)
    );
  }, [searchQuery, getemployeesdata]);
  const handleClear = () => {
    setorgform({
      salutation: "",
      first_name: "",
      middle_name: "",
      last_name: "",
      alias: "",
      gender: "",
      date_of_birth: "",
      blood_group: "",
      marital_status: "",
      father_name: "",
      mother_name: "",
      email: ""
    })
    // const [uploaddocuments form]
    setdeptform({
      name: "",
      parent_department_id: null,
      country_code: "",
      area_code: '',
      landline: "",
      mobile: "",
      email: ""
    })
    setContactDetails([
      { number: '', contact_type: 'Personal', is_available_on_whatsapp: false, is_primary: true, country_code: '+91' }
    ]);
    setCorrespondenceAddress({
      address: '',
      country: '',
      state: '',
      city: '',
      pincode: ''
    });

    setPermanentAddress({
      address: '',
      country: '',
      state: '',
      city: '',
      pincode: ''
    });
    setAcademicDocs([
      { id: Date.now(), qualification: '', board: '', specialization: '', percentage: '', file: null, name: '' }
    ]);

    setOtherDocs([
      { id: Date.now(), documentType: '', documentNumber: '', expiryDate: '', file: null, name: '' }
    ]);
    setOfficialDetails({
      organization: '',
      department: '',
      designation: '',
      reportTo: '',
      employeeCode: '',
      jobType: '',
      workingShift: '',
      dateOfJoining: '',
      employmentType: '',
      subjects: ['']
    });
    setBankDetails({
      accountHolderName: '',
      bankName: '',
      accountNumber: ''
    });
    setNewPermissions([]);
    setAssignedCourses([]);
    setSameAsCorrespondence(false);
    setEmployeeImageFile(null);
    setCapturedPhoto(null);
    setAttendanceType('Biometric Attendance');
    setBiometricImages([]);
    setGeoLocation('');
    setSearchLocation('');
    setPeriphery('');
    setSelectedPlace(null);
    setCurrentStep(0);

  }
  const handleCleardept = () => {
    setdeptform({
      name: "",
      parent_department_id: null,
      country_code: "",
      area_code: '',
      landline: "",
      mobile: "",
      email: ""
    })
    setUpdatebtn(false);
  }
  const handleStatus = async (row) => {
    const newStatus = !row.original.status;
    row.original.status = newStatus;

    const url = `staff/update-employee-status/${row.original.id}/`;

    const response = await patchData(url, { status: newStatus });

    if (response) {
      getorgdata();
      displayToast('Status Uploaded Successfully', 'success')
    }

  };
  const handleStatusDept = async (department) => {

    const newStatus = !department.status;


    const updatedDepartmentDetails = departmentdetails.map(dept => {
      if (dept.id === department.id) {
        return { ...dept, status: newStatus };
      }
      return dept;
    });

    setdepartmentdetails(updatedDepartmentDetails);

    const url = `administration/organizations/${parentorgid}/departments/${department.id}/`;
    const response = await patchData(url, { status: newStatus });

    if (response) {

    } else {
      displayToast("Failed to update department status.", 'danger');
    }
  };
  const handleFilterClickold = () => {
    // onFilter(searchQuery); 
  };
  // const handlePageChange = (data) => {
  //   setCurrentPage(data?.selected);
  // };


  const { skipSpinnerRef, tableLoading, triggerTableLoading, stopTableLoading } = useTableFade();

  const handlePageChange = ({ selected }) => {
    setCurrentPage(selected);
    triggerTableLoading();
    //  getemployees(selected).finally(() => stopTableLoading());
  };




  const getemployees = async (page = 0) => {

    const url = filterQueryString
      ? `staff/get-employees/?${filterQueryString}&page=${page + 1}`
      : `staff/get-employees/?page=${page + 1}`;
    const response = await getData(url);
    if (response) {
      setgetemployeesdata(response.results);
      setgetemployeesdataId(response.results[0]?.user_id);
      setTotalCount(response?.count || 0);
    }


  }
  const pageCounts = Math.ceil(totalCount / pageSize);
  const searchValue = new URLSearchParams(filterQueryString).get("search") || "";



  const handleSyncEmployee = async (id) => {
    try {
      const res = await Postdata(`staff/face-cam/${id}/sync_employee/?async=true`);


      if (res?.status === "success") {
        Notifier.success(res.message || "Employee sync started successfully");
      } else {
        Notifier.error(res?.message || "Failed to start sync");
      }
    } catch (error) {
      console.error("Sync error:", error);
      Notifier.error("Something went wrong while syncing");
    }
  };


  const handleSyncEmployees = async () => {
    try {
      const res = await Postdata('staff/face-cam/sync_all_employees/');


      if (res?.status === "success") {
        const count = res?.total_employees || 0;

        Notifier.success(
          count > 0
            ? `Sync started for ${count} employees.`   // ✔ Friendly message
            : "Employee sync started successfully."
        );
      } else {
        Notifier.error(res?.message || "Unable to start employee sync.");
      }
    } catch (error) {
      console.error("Sync error:", error);
      Notifier.error("Something went wrong. Please try again.");
    }
  };



  const columns = useMemo(
    () => [
      // {
      //   Header: <input type='checkbox' />,
      //   accessor: 'checkbox',
      //   Cell: ({ row }) => (
      //     <input type="checkbox" checked={row.isSelected} onChange={() => row.toggleRowSelected()} />
      //   ),
      // },
      {
        Header: 'Img',
        accessor: 'profile_pic',
        Cell: ({ value }) => {

          const imageUrl = value ? window.baseurl + `media/${value}` : image;
          return (
            <img
              src={value ? imageUrl : image}
              alt="Profile"
              style={{ width: '40px', height: '40px', borderRadius: '8px', border: "1px solid #E9E9E9" }}
            />
          );
        },
      },

      {
        Header: 'Employee\'s Name / ID',
        accessor: 'name',
        Cell: ({ row }) => (
          <div style={{ cursor: 'pointer' }}>
            {/* <p style={{ textAlign: 'left', color: '#222F3E', fontWeight: 500, margin: 0 }}>{row.original.name}</p> */}
            <p
              style={{
                textAlign: "left",
                color: "#222F3E",
                fontWeight: 500,
                margin: 0,
              }}
              dangerouslySetInnerHTML={{
                __html: highlightMatch(
                  row.original?.name,
                  searchValue
                ),
              }}
            />
            <p style={{ textAlign: 'left', margin: 0 }}>({row.original.unique_code})</p>

          </div>
        )
      },

      {
        Header: 'Designation',
        accessor: 'course',
        Cell: ({ row }) => (
          <div >
            <p style={{ textAlign: 'left', color: '#222F3E', fontWeight: 500, margin: 0 }}>{row.original.designation}</p>
          </div>
        )
      },
      {
        Header: 'Department',
        accessor: 'semester',
        Cell: ({ row }) => (
          <div >
            <p style={{ textAlign: 'left', color: '#222F3E', fontWeight: 500, margin: 0 }}>{row.original.department_name}</p>
          </div>
        )
      },
      {
        Header: 'Contacts',
        accessor: 'contacts',
        Cell: ({ row }) => (
          <div>
            {Array.isArray(row.original.contacts) && row.original.contacts.map((contact, idx) => (
              <div key={idx} style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                <img
                  src={contact.is_available_on_whatsapp ? whatsapp : phone}
                  alt="icon"
                  style={{ width: 12, height: 12 }}
                />
                <p>{contact.country_code} {contact.number}</p>

              </div>
            ))}
          </div>
        )
      },
      {
        Header: 'Email',
        accessor: 'email',
        Cell: ({ row }) => (
          <div >
            {/* <p style={{ textAlign: 'left', color: '#222F3E', fontWeight: 500, margin: 0 }}>{row.original.email}</p> */}
            <p
              style={{
                textAlign: "left",
                color: "#222F3E",
                fontWeight: 500,
                margin: 0,
              }}
              dangerouslySetInnerHTML={{
                __html: highlightMatch(
                  row.original?.email,
                  searchValue
                ),
              }}
            />
          </div>
        )
      },

      {
        Header: 'Action',
        Cell: ({ row }) => (
          <div style={{ display: 'flex', gap: '10px' }} >
            <div style={{ display: 'flex', gap: '10px' }}>
              <div class="form-check form-switch custom-switch"  >
                <input class="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckDefault" style={{ cursor: 'pointer' }} checked={row.original.status} onChange={() => handleStatus(row)}
                  title='Enabled/Diabled' />
              </div>
            </div>
            <img src={edit} style={{ cursor: 'pointer' }} title='Edit Details' onClick={() => { handleEditClick(row.original.id, row.original) }}></img>
            {/* {
              (row.original.permanent_registration_number &&
                row?.original?.admission_status !== 'Cancelled') ? ( */}

            <img
              src={tablelast}
              alt="Options"
              style={{ cursor: 'pointer' }}
              onClick={() => {
                handleRowClick(row.original.id);
                // handlegenerateIdcard(row.original.id);
                setidcardmodal(true);
              }}
              title='Generate ID Card'
              data-tooltip-id="admission-tip" data-tooltip-content="Generate ID Card"
            />
            <svg fill="#7F56DA" viewBox="0 0 24 24" id="update-alt" data-name="Flat Line" xmlns="http://www.w3.org/2000/svg" className="icon flat-line" width="25" height="25" style={{ cursor: 'pointer' }}

              onClick={(e) => {
                e.stopPropagation();       // ✅ prevent row click event bubbling
                handleSyncEmployee(row.original.id);

              }}


            ><title>Create / Update syncing employee</title>
              <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
              <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
              <g id="SVGRepo_iconCarrier">
                <path
                  id="primary"
                  d="M5.07,8A8,8,0,0,1,20,12"
                  style={{
                    fill: "none", stroke: "#7F56DA", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2,
                  }}
                ></path>
                <path id="primary-2" d="M18.93,16A8,8,0,0,1,4,12" style={{
                  fill: "none", stroke: "#7F56DA", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2,
                }} ></path>
                <polyline id="primary-3" points="5 3 5 8 10 8" style={{
                  fill: "none", stroke: "#7F56DA", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2,
                }}
                ></polyline>
                <polyline id="primary-4" points="19 21 19 16 14 16" style={{
                  fill: "none", stroke: "#7F56DA", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2,
                }}
                ></polyline>
              </g>
            </svg>
          </div>
        ),
      },
    ],
    [searchValue]
  );

  useEffect(() => {
    getbasicmasterdata();
    getcountry();
    getuploaddocmasterdata();
    getofficialdetailmasterdata();
    getorgdataorg();
    getAllCourses();
    // getorgdata()
  }, [])



  useEffect(() => {

    getemployees(currentPage)
      .finally(() => stopTableLoading()); // hide fade overlay
  }, [currentPage, filterQueryString]);



  // Set or clear one query param; the [currentPage, filterQueryString] effect refetches.
  const updateFilterParam = (key, value) => {
    setFilterQueryString(prev => {
      const queryParams = new URLSearchParams(prev);
      if (value) {
        queryParams.set(key, value);
      } else {
        queryParams.delete(key);
      }
      return queryParams.toString();
    });
    setCurrentPage(0);
  };

  const handleSearch = (query) => {
    setSearchQuery(query);
    updateFilterParam("search", query);
  };

  const statusFilter = new URLSearchParams(filterQueryString).get("status") || "";
  const debouncedSearch = useMemo(() => debounce(handleSearch, 100), []);
  useEffect(() => {
    return () => debouncedSearch.cancel(); // cleanup
  }, []);



  useEffect(() => {
    const fetchAllData = async () => {
      if (isEditMode && selectedUserId) {
        setIsLoadingFormDetails(true)
        try {
          const [basicRes, uploadDocRes, officialRes] = await Promise.all([
            getData(`staff/teacher-basic-details/${selectedUserId}/`),
            getData(`staff/get-teacher-document-details/${selectedUserId}/`),
            getData(`staff/teacher-official-details/${selectedUserId}/`)
          ]);

          const basicData = await basicRes;
          const uploadData = await uploadDocRes;
          const officialData = await officialRes;

          if (basicData.addresses && Array.isArray(basicData.addresses)) {
            const permanent = basicData.addresses.find(addr => addr.address_type === 'Permanent');
            const correspondence = basicData.addresses.find(addr => addr.address_type === 'Current');


            const countryId = permanent?.country_id || '';
            setcountryId(countryId);


            if (countryId) {
              const stateResponse = await getData(`administration/countries/${countryId}/states/`);
              setstatedata(stateResponse.state_list || []);


              const stateId = permanent?.state_id || '';
              setstateid(stateId);


              if (stateId) {
                const cityResponse = await getData(`administration/countries/${countryId}/states/${stateId}/cities/`);
                setcitydata(cityResponse.city_list || []);

                // Set city
                setcityid(permanent?.city_id || '');
              }
            }

            if (permanent) {
              setPermanentAddress({
                address: permanent.address || '',
                country: permanent.country_id || '',
                state: permanent.state_id || '',
                city: permanent.city_id || '',
                pincode: permanent.pincode || ''
              });
            }

            if (correspondence) {
              setCorrespondenceAddress({
                address: correspondence.address || '',
                country: correspondence.country_id || '',
                state: correspondence.state_id || '',
                city: correspondence.city_id || '',
                pincode: correspondence.pincode || ''
              });
            }
          }

          // Rest of your existing code...
          setorgform(basicData);
          setContactDetails(basicData.contact_numbers);

          // Academic Docs
          setAcademicDocs(
            uploadData.qualifications && uploadData.qualifications.length > 0
              ? uploadData.qualifications.map((item) => ({
                id: item.id,
                qualification: item.qualification_type || '',
                board: item.board || '',
                specialization: item.subjects?.[0]?.subject || '',
                percentage: item.percentage || '',
                file: item.documents?.[0]?.document || null,
                name: item.documents?.[0]?.document || null,
              }))
              : [{ id: Date.now(), qualification: '', board: '', specialization: '', percentage: '', file: null }]
          );

          setOtherDocs(
            uploadData.employee_documents && uploadData.employee_documents.length > 0
              ? uploadData.employee_documents.map((item) => ({
                id: item.id,
                documentType: item.document_type || '',
                documentNumber: item.document_number || '',
                expiryDate: item.validity || '',
                file: item.document || null
              }))
              : [{ id: Date.now(), documentType: '', documentNumber: '', expiryDate: '', file: null }]
          );
          const imgurl = uploadData.profile_picture ? window.baseurl + `media/` + uploadData.profile_picture : null;
          setEmployeeImageFile(null);
          setCapturedPhoto(imgurl)

          setOfficialDetails({

            organization: officialData.organization_id || '',
            department: officialData.department_id || '',

            designation: officialData.designation_id || '',

            reportTo: officialData.manager_id || '',
            employeeCode: officialData.unique_code || '',
            jobType: officialData.job_type || '',
            workingShift: officialData.working_shift || '',
            dateOfJoining: officialData.date_of_joining || '',
            employmentType: officialData.employment_type || '',
            subjects: officialData.subjects || [],
            uniquecode: officialData.unique_code
          });
          setparentidfromorg(officialData.organization_id)
          if (officialData.new_permissions && Array.isArray(officialData.new_permissions)) {
            setNewPermissions(
              officialData.new_permissions.map((perm) => ({
                id: perm.id,
                name: perm.name
              }))
            );
          }
          if (officialData.subjects && Array.isArray(officialData.subjects)) {
            setAssignedCourses(
              officialData.subjects.map((course) => ({
                value: course.id ?? course,
                label: course.course_name ?? course.name ?? String(course)
              }))
            );
          }

          setBankDetails({
            bank_id: officialData.bank_id,
            accountHolderName: officialData.account_holder_name,
            bankName: officialData.bank,
            accountNumber: officialData.bank_account_number
          });
          if (officialData.organization_id) {
            const departmentResponse = await getData(`administration/organizations/${officialData.organization_id}/departments/`);
            setdepartmentfromorg(departmentResponse);
            if (officialData.department_id) {
              const designationResponse = await getData(
                `administration/organizations/${officialData.organization_id}/departments/${officialData.department_id}/designations/`
              );
              setdesigfromorg(designationResponse);
            }
          }

        } catch (err) {
          displayToast("❌ Failed to fetch employee data:", 'danger');
        } finally {
          setTimeout(() => setIsLoadingFormDetails(false), 300);
        }
      }
    };

    fetchAllData();
  }, [isEditMode, selectedUserId]);

  useEffect(() => {
    const handleRowClick = async () => {
      const token = sessionStorage.getItem("token");

      try {

        if (getemployeesdataId) {
          const response = await getData(`staff/get-employees/${getemployeesdataId}/`)

          setSelectedOrgDetails(response);
          localStorage.setItem("selectedEmployeeData", JSON.stringify(response));

        }
      } catch (error) {
        displayToast("❌ Error fetching employee data:", 'danger');
      }
    };
    handleRowClick()
  }, [getemployeesdataId])

  return (
    <>
      <div style={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        overflow: "hidden",
      }}>

        {/* ── FIXED: Title + Add Button ── */}
        <div style={{ flexShrink: 0, padding: "0 12px" }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <h2 className="main-heading">Employee Dashboard</h2>
            <button className="add-btn" onClick={openModal}>
              <span className="me-2">
                <svg width="12" height="12" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M20.4286 13.3537H12.5714V21.2108C12.5714 21.6276 12.4059 22.0273 12.1112 22.322C11.8165 22.6167 11.4168 22.7822 11 22.7822C10.5832 22.7822 10.1835 22.6167 9.88883 22.322C9.59413 22.0273 9.42857 21.6276 9.42857 21.2108V13.3537H1.57143C1.15466 13.3537 0.754961 13.1881 0.460261 12.8934C0.165561 12.5987 0 12.199 0 11.7822C0 11.3655 0.165561 10.9658 0.460261 10.6711C0.754961 10.3764 1.15466 10.2108 1.57143 10.2108H9.42857V2.35366C9.42857 1.93689 9.59413 1.53719 9.88883 1.24249C10.1835 0.947787 10.5832 0.782227 11 0.782227C11.4168 0.782227 11.8165 0.947787 12.1112 1.24249C12.4059 1.53719 12.5714 1.93689 12.5714 2.35366V10.2108H20.4286C20.8453 10.2108 21.245 10.3764 21.5397 10.6711C21.8344 10.9658 22 11.3655 22 11.7822C22 12.199 21.8344 12.5987 21.5397 12.8934C21.245 13.1881 20.8453 13.3537 20.4286 13.3537Z" fill="white" />
                </svg>
              </span>
              Add New Employee
            </button>
          </div>
        </div>

        {/* ── FIXED: Search + Filters ── */}
        <div style={{ flexShrink: 0, padding: "8px 12px" }}>
          <div className="row align-items-center">
            <div className="col-md-6">
              <h4 className="text-primary">Employees ({totalCount})</h4>
            </div>
            <div className="col-md-6">
              <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "center", gap: "8px" }}>
                <SearchBar
                  data={getemployeesdata}
                  onSearch={debouncedSearch}
                  placeholder="Search by Name, Phone No, Email.."
                />
                <select
                  className="form-select"
                  style={{ width: "140px", height: "40px", flexShrink: 0 }}
                  value={statusFilter}
                  onChange={(e) => updateFilterParam("status", e.target.value)}
                  title="Filter by status"
                >
                  <option value="">All Status</option>
                  <option value="active">Active</option>
                  <option value="inactive">Inactive</option>
                </select>
                <button
                  className="filter-btn"
                  style={{ background: "white", height: "40px" }}
                  onClick={handleSyncEmployees}
                  title="Create / Update syncing employee"
                >
                  <svg fill="#7F56DA" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" width="35" height="35" style={{ cursor: "pointer" }}>
                    <path d="M5.07,8A8,8,0,0,1,20,12" style={{ fill: "none", stroke: "#7F56DA", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2 }} />
                    <path d="M18.93,16A8,8,0,0,1,4,12" style={{ fill: "none", stroke: "#7F56DA", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2 }} />
                    <polyline points="5 3 5 8 10 8" style={{ fill: "none", stroke: "#7F56DA", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2 }} />
                    <polyline points="19 21 19 16 14 16" style={{ fill: "none", stroke: "#7F56DA", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2 }} />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* ── SCROLLABLE BOTTOM: Table (left) + Details (right) ── */}
        <div style={{
          display: "flex",
          flex: 1,
          minHeight: 0,
          overflow: "hidden",
          padding: "0 12px",
          alignItems: "stretch",
          position: "relative",
        }}>

          {/* LEFT: Table */}
          <div style={{
            flex: "0 0 75%",
            maxWidth: "75%",
            display: "flex",
            flexDirection: "column",
            minHeight: 0,
            overflow: "hidden",
            paddingRight: "12px",
          }}>
            <Table
              data={dataemploye}
              columns={columns}
              selectedOrgDetails={selectedOrgDetails}
              pageCounts={pageCounts}
              handlePageChange={handlePageChange}
            />
          </div>

          {/* RIGHT: Short Details */}
          <div className="shortdetails" style={{
            flex: "0 0 25%",
            maxWidth: "25%",
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
          }}>
            <UserShortDetails
              navigate={navigate}
              closeModaldept={closeModaldept}
              isModalOpendept={isModalOpendept}
              openModaldept={openModaldept}
              selectedOrgDetails={selectedOrgDetails}
              departmentdetails={departmentdetails}
              deptform={deptform}
              handleChangedept={handleChangedept}
              handleSubmitdept={handleSubmitdept}
              handleEditdept={handleEditdept}
              Updatebtn={Updatebtn}
              handleupdatedept={handleupdatedept}
              handleCleardept={handleCleardept}
              handleStatusDept={handleStatusDept}
              getemployeesdataId={getemployeesdataId}
            />
          </div>

          <TableLoaderOverlay isLoading={tableLoading} />
        </div>
      </div>
      <div>
        <AddNewEmployeeModal isOpen={isModalOpen} onClose={closeModal} setsubmit={setsubmit}
          orgform={orgform} setorgform={setorgform} getbasicmaster={getbasicmaster} contactDetails={contactDetails} setContactDetails={setContactDetails} handleContactChange={handleContactChange} handleChange={handleChange} handlePrimarySelect={handlePrimarySelect}
          handleSubmitbasic={handleSubmitbasic} countryId={countryId} stateid={stateid} countrydata={countrydata} handlelocationdata={handlelocationdata} statedata={statedata} citydata={citydata} handleSameAsCorrespondence={handleSameAsCorrespondence} handleCorrespondenceChange={handleCorrespondenceChange} handlePermanentChange={handlePermanentChange} correspondenceAddress={correspondenceAddress} setCorrespondenceAddress={setCorrespondenceAddress} permanentAddress={permanentAddress} setPermanentAddress={setPermanentAddress} sameAsCorrespondence={sameAsCorrespondence} setSameAsCorrespondence={setSameAsCorrespondence} academicDocs={academicDocs}
          setAcademicDocs={setAcademicDocs} otherDocs={otherDocs}
          setOtherDocs={setOtherDocs} setgetuploaddocmaster={setgetuploaddocmaster} uploaddoc={uploaddoc}
          capture={capture} showCamera={showCamera} setShowCamera={setShowCamera} capturedPhoto={capturedPhoto} setCapturedPhoto={setCapturedPhoto} webcamRef={webcamRef}
          handleOtherDocChange={handleOtherDocChange} handleAcademicChange={handleAcademicChange}
          handleAcademicFileRemove={handleAcademicFileRemove}
          handleAcademicFileChange={handleAcademicFileChange}
          handleOtherFileChange={handleOtherFileChange}
          handleRemoveOtherFile={handleRemoveOtherFile}
          employeeImageFile={employeeImageFile}
          setEmployeeImageFile={setEmployeeImageFile} handleEmployeeImageChange={handleEmployeeImageChange}
          handleSubmituploaddocument={handleSubmituploaddocument} submitEmployeeImage={submitEmployeeImage} handleOfficialChange={handleOfficialChange} handleBankChange={handleBankChange} bankDetails={bankDetails} setBankDetails={setBankDetails} officialDetails={officialDetails} setOfficialDetails={setOfficialDetails}
          getofficialdetailmaster={getofficialdetailmaster}
          departmentfromorg={departmentfromorg} desigfromorg={desigfromorg}
          handleSubmitOfficialDetails={handleSubmitOfficialDetails} selectedUserId={selectedUserId}
          isEditMode={isEditMode} currentStep={currentStep} setCurrentStep={setCurrentStep}
          biometricImages={biometricImages} setBiometricImages={setBiometricImages} geoLocation={geoLocation}
          setGeoLocation={setGeoLocation} searchLocation={searchLocation} setSearchLocation={setSearchLocation}
          periphery={periphery} setPeriphery={setPeriphery}
          selectedPlace={selectedPlace} setSelectedPlace={setSelectedPlace} attendanceType={attendanceType}
          setAttendanceType={setAttendanceType} handleUpdateBasicDetails={handleUpdateBasicDetails}
          emoployeeId={emoployeeId} setfuncsuc={setfuncsuc} funcsuc={funcsuc}
          getorgdata={getorgdata}
          setIsEditMode={setIsEditMode}
          setdepartmentfromorg={setdepartmentfromorg}
          setdesigfromorg={setdesigfromorg}
          handlePermissionChange={handlePermissionChange}
          newPermissions={newPermissions}
          setNewPermissions={setNewPermissions}
          setSelectedUserId={setSelectedUserId}
          setorgdata={setorgdata}
          orgdata={orgdata}
          attendanceid={attendanceid}
          isLoadingFormDetails={isLoadingFormDetails}
          assignedCourses={assignedCourses}
          setAssignedCourses={setAssignedCourses}
          allCourses={allCourses}
          setApprovalRequestId={setApprovalRequestId}
          editSessionId={editSessionId}
        />
      </div>

      <WaitApprovalForEmployeeChange
        key={approvalRequestId || 'idle'}
        isOpen={!!approvalRequestId}
        requestId={approvalRequestId}
        onApproved={() => {
          setApprovalRequestId(null);
          getemployees();
          closeModal();
        }}
        onRejectedOrCancelled={() => {
          setApprovalRequestId(null);
        }}
        onClose={() => setApprovalRequestId(null)}
      />

      {submit === true ? <>
        <div className="modal-overlay">
          <div className="modal-content-success" style={{ position: 'relative' }}>
            <div className="modal-header-content" style={{ display: 'flex', justifyContent: 'end', alignItems: 'center', marginBottom: '10px' }}>
              <button className="close-btn" onClick={submitclose}><img src={close}></img></button>
            </div>
            <div className="row justify-content-center mb-2" >
              <div className="col-md-12" style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center' }}>
                <img src={successgif} style={{ width: '100px', height: '100px' }}></img>
                {isEditMode ? <p>Details Updated Successfully!</p> : <p>Employee created Successfully!</p>}

              </div>
              <div style={{ border: "1px dotted #222F3E4D", width: '159px' }} ></div>
            </div>

            <div className="row justify-content-center mt-2">

            </div>
          </div>
        </div>
      </> : ''}



      {idcardmodal ? <GenerateEmployeeIdModal isOpen={idcardmodal} onClose={() => setidcardmodal(false)} selectedOrgDetails={selectedOrgDetails} setCapturedPhoto={setCapturedPhoto} capturedPhoto={capturedPhoto}
        setShowEditor={setShowEditor} setFingerprints={setFingerprints} fingerprints={fingerprints}
        setimgurl={setimgurl} setidcardmodal={setidcardmodal} setidcarddata={setidcarddata} idcarddata={idcarddata}
      /> : ''}
      {showEditor && (
        <PhotoEditor capturedPhoto={capturedPhoto} setCapturedPhoto={setCapturedPhoto} setShowEditor={setShowEditor} setshowvaliditymodal={setshowvaliditymodal}// setpaymentmodal={setpaymentmodal}
          imgurl={imgurl} setimgurl={setimgurl} setFingerprints={setFingerprints} selectedOrgDetails={selectedOrgDetails} fingerprints={fingerprints} />
      )}


      {showToast && (
        <div
          className={`custom-toast toast align-items-center text-white bg-${toastVariant} border-0 position-fixed top-0 end-0 m-3`}
          role="alert"
          style={{
            display: 'block',
            minWidth: '300px',
            maxWidth: '400px',
            borderRadius: '8px',
            boxShadow: '0 6px 20px rgba(0,0,0,0.15)',
            fontSize: '15px',
            zIndex: 9999
          }}
        >
          <div className="d-flex">
            <div className="toast-body" style={{ padding: '12px 16px' }}>
              <strong>{toastVariant === 'success' ? '✅' : '❌'} </strong> {toastMessage}
            </div>
            <button
              type="button"
              className="btn-close btn-close-white me-2 m-auto"
              onClick={() => setShowToast(false)}
              aria-label="Close"
            ></button>
          </div>
        </div>

      )}
    </>
  );
};

export default EmployeeDashboard;
